import { AccessPermissionType } from "./accessPermisionType";
import { CustomAffichage, ProprieteAffichee, TypePropriete } from "./proprieteAffichee";
import { ReferentielDonneeAnalyse } from "./referentielDonneeAnalyse";
import { Site } from "./site";

export class ConfigurationSaisieDonneesAnalyse {
  configurationSaisieDonneesAnalyseId: number;
  referentielDonneeAnalyseId: number;
  siteId: number;
  isEnabled: boolean;
  modeSaisieDonneeProjet: number;
  txtModeSaisieDonneeProjet: string;
  referentielDonneeAnalyse: ReferentielDonneeAnalyse;
  site: Site;
  profilId: number;
  valeurNominal: number;
  valeurMin: number;
  valeurMax: number;
  accessPermission: AccessPermissionType;
  description: string;
  libelleUniteReferentiel: string;
  displayUnit: string;
  quantityType: string;
  


  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('referentielDonneeAnalyse', 'GLOBAL.NOM', 'nom'));
    tab.push(new ProprieteAffichee('referentielDonneeAnalyse', 'CONFIGURATION_DONNEES.TYPE', 'nomTypeReferentiel'));
    tab.push(new ProprieteAffichee('referentielDonneeAnalyse', 'CONFIGURATION_DONNEES.UNITE', 'nomUniteReferentiel'));
    tab.push(new ProprieteAffichee('isEnabled', 'CONFIGURATION_DONNEES.IS_ENABLED', '',
      new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));
    tab.push(new ProprieteAffichee('accessPermission', 'ACCESS_PERMISSION.ACCESS_PERMISSION', '',
      new CustomAffichage(TypePropriete.UserPermission)));
    tab.push(new ProprieteAffichee('txtModeSaisieDonneeProjet', 'CONFIGURATION_DONNEES.DONNEE_PROJET'));
    tab.push(new ProprieteAffichee('valeurMin', 'CONFIGURATION_DONNEES.VALEUR_MIN', '', new CustomAffichage(TypePropriete.Number)));
    tab.push(new ProprieteAffichee('valeurMax', 'CONFIGURATION_DONNEES.VALEUR_MAX', '', new CustomAffichage(TypePropriete.Number)));
    tab.push(new ProprieteAffichee('valeurNominal', 'CONFIGURATION_DONNEES.VALEUR_NOMINAL', '', new CustomAffichage(TypePropriete.Number)));
    return tab;
  }
}

export enum ModeSaisie {
  Manuelle,
  Somme,
  Moyenne,
  Min,
  Max,
  Median,
  Product,
  Percent,
  Graphe
}
